import React from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Card,
    CardActionArea,
    CardContent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RichText from '../../components/RichText';
import ItemIconV3 from './ItemIconV3';
import GetItemData from "../containers/GetItemData";
import { EQUIPMENT_STYLES } from '../constants/equipmentConstants';

export default function ItemView({ itemCode }) {
    const theme = useTheme();
    // Теперь ItemView не заботится о токене и фетче – этим управляет GetItemData

    // Стили для свёрнутого состояния описания (одна строка, с многоточием)
    const truncatedTextStyles = {
        display: '-webkit-box',
        WebkitLineClamp: '1',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };

    // Динамические стили для контейнера текста и иконки (для описания)
    const [expanded, setExpanded] = React.useState(false);
    const containerStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: expanded ? 'flex-start' : 'center',
    };

    return (
        <GetItemData itemCode={itemCode}>
            {(itemData) => (
                <Box sx={{ mb: 1 }}>
                    {/* Верхняя часть: иконка, название и подтип с чипом */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <ItemIconV3 icon={itemData.icon} size={48} />
                        <Box sx={{ width: 16 }} /> {/* Spacer */}
                        <Box>
                            <Typography variant="body2" sx={{ fontFamily: EQUIPMENT_STYLES.FONT_FAMILY_QUANTITY }}>
                                <RichText content={itemData.name} />
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: EQUIPMENT_STYLES.FONT_FAMILY_QUANTITY }}>
                                <RichText content={itemData.type} />
                                {/* Если присутствует tagName, выводим чип */}
                                {itemData.tagName && (
                                    <>
                                        {' '}
                                        <Box
                                            component="span"
                                            sx={{
                                                display: 'inline-block',
                                                verticalAlign: 'middle',
                                                px: 1,
                                                py: 0,
                                                ml: 0.5,
                                                borderRadius: '4px',
                                                backgroundColor: itemData.tagColor || '#000',
                                                color: '#fff',
                                                fontSize: '0.7rem',
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {itemData.tagName}
                                        </Box>
                                    </>
                                )}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Таблица со статистикой, если она есть */}
                    {Array.isArray(itemData.effects) && itemData.effects.length > 0 && (
                        <Table size="small" sx={{ mb: 2 }}>
                            <TableBody>
                                {itemData.effects.map((effect, idx) => (
                                    <TableRow key={idx} sx={{ '& td': { borderBottom: 'none', py: 0.75 } }}>
                                        <TableCell
                                            sx={{
                                                width: '70%',
                                                verticalAlign: 'top',
                                                pl: 0,
                                                fontFamily: EQUIPMENT_STYLES.FONT_FAMILY_QUANTITY
                                            }}
                                        >
                                            <RichText content={effect.label} />
                                        </TableCell>
                                        <TableCell align="right" sx={{ width: '30%', pr: 0, fontFamily: EQUIPMENT_STYLES.FONT_FAMILY_QUANTITY }}>
                                            <RichText content={effect.value} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}

                    {/* Описание с возможностью разворачивания/сворачивания */}
                    {itemData.description?.trim() && (
                        <Card
                            variant="outlined"
                            sx={{
                                boxShadow: 'none',
                                backgroundColor: theme.palette.grey[100],
                            }}
                        >
                            <CardActionArea onClick={() => setExpanded((prev) => !prev)}>
                                <CardContent sx={{ p: 1 }}>
                                    <Box sx={containerStyles}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                ...(expanded ? {} : truncatedTextStyles),
                                                fontFamily: EQUIPMENT_STYLES.FONT_FAMILY_QUANTITY
                                            }}
                                        >
                                            {itemData.description}
                                        </Typography>
                                        <Box sx={{ ml: 1, mt: expanded ? 0.5 : 0 }}>
                                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    )}
                </Box>
            )}
        </GetItemData>
    );
}